var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.97008,
    d: "M2.35193 2.35181C-0.770957 5.47471 -0.770957 10.5446 2.35193 13.6675C5.47483 16.7904 10.5447 16.7904 13.6676 13.6675C16.7905 10.5446 16.7905 5.47471 13.6676 2.35181C10.5447 -0.771078 5.43627 -0.790355 2.35193 2.35181ZM12.7037 12.7036C10.1013 15.306 5.86037 15.306 3.25796 12.7036C0.655549 10.1012 0.655549 5.87953 3.27724 3.27712C5.89892 0.674706 10.1206 0.674706 12.723 3.27712C15.3254 5.87953 15.3062 10.1205 12.7037 12.7036Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.97008,
    d: "M8.00021 4.20242C7.63394 4.20242 7.34478 4.49158 7.34478 4.85785V7.36387H4.81948C4.45322 7.36387 4.16406 7.65302 4.16406 8.01929C4.16406 8.38555 4.45322 8.67471 4.81948 8.67471H7.32551V11.1807C7.32551 11.547 7.61466 11.8362 7.98093 11.8362C8.15442 11.8362 8.32792 11.759 8.44358 11.6434C8.55924 11.5277 8.63635 11.3542 8.63635 11.1807V8.67471H11.1424C11.3159 8.67471 11.4894 8.5976 11.605 8.48194C11.7207 8.36628 11.7978 8.19278 11.7978 8.01929C11.7978 7.65302 11.5086 7.36387 11.1424 7.36387H8.63635V4.85785C8.65563 4.4723 8.36647 4.20242 8.00021 4.20242Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.32cf0e2a.svg";
export { ForwardRef as ReactComponent };